module.exports = __webpack_public_path__ + "static/media/Hobbies.3223ec61.jpg";